import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IdentityService } from 'src/app/@core/services/identity.service';
import { LearningPathModel } from 'src/app/learning-path/models/learning-path.model';
import { LearningPathService } from 'src/app/learning-path/services/learning-path.service';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from 'src/app/shared/models/item.model';
import { DisplayInHomeFilterModel } from '../../models/display-filter.model';
import { CarouselResize } from 'src/app/shared/models/carousel-resize';
import { environment } from 'src/environments/environment';
import { CustomCarouselComponent } from 'src/app/shared/components/custom-carousel/custom-carousel.component';

@Component({
  selector: 'app-training-tracks',
  templateUrl: './training-tracks.component.html',
  styleUrls: ['./training-tracks.component.scss']
})
export class TrainingTracksComponent implements OnInit {
  @Input() title:string;
  @Input() description: string;
  isRtl: boolean = true;
  mediaUrl: string = environment.mediaUrl;
  filter: DisplayInHomeFilterModel = new DisplayInHomeFilterModel();
  carouselResize: CarouselResize<LearningPathModel> = {
    data: [],
    items: [],
    itemSizeSm: 1,
    itemSizeMd: 4,
    itemSizeLg: 4,
    itemResize: 0,
    innerWidth: 0,
    currentIndex: 0,
    slideDelay: 20000
  }
  @ViewChild('appCustomCarousel') appCustomCarousel: CustomCarouselComponent<LearningPathModel>;  
  constructor(private pathService: LearningPathService, private _LanguageService: LanguageService, private _IdentityService: IdentityService){}

  /** Unified Code mode: tokenised layout (styles/unified-code/components/_home.scss). */
  get isUnified(): boolean {
    return this._IdentityService.isUnifiedCode();
  }

  ngOnInit(): void {
    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => this.isRtl = result === LanguageEnum.ar);
    this.getLearningPaths();
  }
  getLearningPaths(): void {
    this.pathService.getPaging(this.filter).subscribe(result => this.carouselResize.data = result.data)
  }
}
